import React from 'react';
import {Field} from "formik";
import {FormikSetFieldValue} from "../../../types/CommonTypes";

type Props = {
    text:string
    value?:string
    name:string
    setFieldValue:FormikSetFieldValue
}
const RowDateFilter:React.FC<Props> = ({setFieldValue,value,text,name}) => {

    const handleChange= (event:React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue(name,event.currentTarget.value)
    }
    return (
        <div className="form-filter__item form-filter__item-id1">
            <span  className="id1__label1">
                {text}
            </span>
            <Field
                placeholder="yyyy-mm-dd"
                type="date"
                value={value}
                name="registration_date"
                className="id1__input1"
                onChange={handleChange}
            />
        </div>
    );
};

export default RowDateFilter;